import { useContext } from 'react';
import { DrawerContext } from 'providers/DrawerProvider';
import type { ContextProps } from 'providers/DrawerProvider';

export function useDrawer(): ContextProps {
  const { openDrawer, closeDrawer } = useContext(DrawerContext);

  return { openDrawer, closeDrawer };
}
